export const numberToWord = (num: number): string => {
  const words = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten']
  return num <= 10 ? words[num] : num.toString()
}

export const abbreviateLocation = (location: string): string => {
  const stateAbbreviations: { [key: string]: string } = {
    'New South Wales': 'NSW',
    'Victoria': 'VIC', 
    'Queensland': 'QLD',
    'Western Australia': 'WA',
    'South Australia': 'SA',
    'Tasmania': 'TAS',
    'Northern Territory': 'NT',
    'Australian Capital Territory': 'ACT'
  }
  
  const countryAbbreviations: { [key: string]: string } = {
    'Australia': 'AUS',
    'New Zealand': 'NZ',
    'United States': 'USA',
    'United Kingdom': 'UK',
    'Canada': 'CAN'
  }
  
  let abbreviated = location
  
  // Replace states
  Object.entries(stateAbbreviations).forEach(([full, abbrev]) => {
    abbreviated = abbreviated.replace(full, abbrev)
  })
  
  // Replace countries
  Object.entries(countryAbbreviations).forEach(([full, abbrev]) => {
    abbreviated = abbreviated.replace(full, abbrev)
  })
  
  return abbreviated
}